import React from "react";

// Slow editorial marquee. Duplicates items for a seamless loop.
export const Marquee = ({ items = [], className = "", duration = 42 }) => {
  const loop = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
      <div className="flex w-max marquee-track" style={{ animationDuration: `${duration}s` }}>
        {loop.map((it, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display text-[9vw] lg:text-[6.5vw] leading-none text-ink/[0.07] px-6 whitespace-nowrap select-none">
              {it}
            </span>
            <span className="h-3 w-3 rounded-full bg-gold/40 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
